<template>
  <div id="form-revision">
    <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
      <v-icon right dark>arrow_back_ios</v-icon>Volver
    </v-btn>
    <v-container grid-list-xl>
      <v-card>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text"
            ><br /><br />Detalle Acomodacion<br /><br
          /></v-toolbar-title>
        </v-toolbar>
        <br /><br />
        <v-card>
          <v-toolbar color="white" dark flat dense cad>
            <v-toolbar-title class="indigo--text"
              ><br /><br />Datos Estudiante<br /><br
            /></v-toolbar-title>
          </v-toolbar>
          <v-layout>
            <v-flex xs12 md1></v-flex>
            <v-flex xs12 md12>
              <!-- INICIO DATOS  -->
              <template>
                <v-form ref="form" v-model="validacion" lazy-validation>
                  <v-layout>
                    <v-flex>
                      <v-text-field
                        v-model="rutEstudiante"
                        :error-messages="rutEstudianteErrors"
                        label="Rut Estudiante"
                        :box="tipeView == 'consulta'"
                        :readonly="tipeView == 'consulta'"
                        @input="$v.rutEstudiante.$touch()"
                        @blur="
                          tipeView == 'crear' ? $v.rutEstudiante.$touch() : null
                        "
                      ></v-text-field>
                      <v-text-field
                        v-model="nombreEstudiante"
                        :error-messages="nombreEstudianteErrors"
                        label="Nombre Estudiante"
                        :box="tipeView == 'consulta'"
                        :readonly="tipeView == 'consulta'"
                        @input="$v.nombreEstudiante.$touch()"
                        @blur="
                          tipeView == 'crear'
                            ? $v.nombreEstudiante.$touch()
                            : null
                        "
                      ></v-text-field>
                      <v-text-field
                        v-model="regionEstudiante"
                        :error-messages="regionEstudianteErrors"
                        label="Region"
                        :box="tipeView == 'consulta'"
                        :readonly="tipeView == 'consulta'"
                        @input="$v.regionEstudiante.$touch()"
                        @blur="
                          tipeView == 'crear'
                            ? $v.regionEstudiante.$touch()
                            : null
                        "
                      ></v-text-field>
                      <v-text-field
                        v-model="comunaEstudiante"
                        :error-messages="comunaEstudianteErrors"
                        label="Comuna"
                        :box="tipeView == 'consulta'"
                        :readonly="tipeView == 'consulta'"
                        @input="$v.comunaEstudiante.$touch()"
                        @blur="
                          tipeView == 'crear'
                            ? $v.comunaEstudiante.$touch()
                            : null
                        "
                      ></v-text-field>
                      <v-text-field
                        v-model="rbd"
                        :error-messages="rbdErrors"
                        label="RBD"
                        :box="tipeView == 'consulta'"
                        :readonly="tipeView == 'consulta'"
                        @input="$v.rbd.$touch()"
                        @blur="tipeView == 'crear' ? $v.rbd.$touch() : null"
                      ></v-text-field>
                      <v-text-field
                        v-model="codigoCurso"
                        :error-messages="codigoCursoErrors"
                        label="Codigo Curso"
                        :box="tipeView == 'consulta'"
                        :readonly="tipeView == 'consulta'"
                        @input="$v.codigoCurso.$touch()"
                        @blur="
                          tipeView == 'crear' ? $v.codigoCurso.$touch() : null
                        "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md1></v-flex>
                    <v-flex>
                      <v-text-field
                        v-model="nivel"
                        :error-messages="nivelErrors"
                        label="Nivel"
                        :box="tipeView == 'consulta'"
                        :readonly="tipeView == 'consulta'"
                        @input="$v.nivel.$touch()"
                        @blur="tipeView == 'crear' ? $v.nivel.$touch() : null"
                      ></v-text-field>
                      <v-text-field
                        v-model="letra"
                        :error-messages="letraErrors"
                        label="Letra"
                        :box="tipeView == 'consulta'"
                        :readonly="tipeView == 'consulta'"
                        @input="$v.letra.$touch()"
                        @blur="tipeView == 'crear' ? $v.letra.$touch() : null"
                      ></v-text-field>
                      <v-text-field
                        v-model="idDiscapacidad"
                        :error-messages="idDiscapacidadErrors"
                        label="Id Discapacidad"
                        :box="tipeView == 'consulta'"
                        :readonly="tipeView == 'consulta'"
                        @input="$v.idDiscapacidad.$touch()"
                        @blur="
                          tipeView == 'crear'
                            ? $v.idDiscapacidad.$touch()
                            : null
                        "
                      ></v-text-field>
                      <v-text-field
                        v-model="tipoDiscapacidad"
                        :error-messages="tipoDiscapacidadErrors"
                        label="Tipo Discapacidad"
                        :box="tipeView == 'consulta'"
                        :readonly="tipeView == 'consulta'"
                        @input="$v.tipoDiscapacidad.$touch()"
                        @blur="
                          tipeView == 'crear'
                            ? $v.tipoDiscapacidad.$touch()
                            : null
                        "
                      ></v-text-field>
                      <v-text-field
                        v-model="asignacionExaminador"
                        :error-messages="asignacionExaminadorErrors"
                        label="Asignacion Examinador"
                        :box="tipeView == 'consulta'"
                        :readonly="tipeView == 'consulta'"
                        @input="$v.asignacionExaminador.$touch()"
                        @blur="
                          tipeView == 'crear'
                            ? $v.asignacionExaminador.$touch()
                            : null
                        "
                      ></v-text-field>
                      <v-text-field
                        v-model="prioridadCompetencias"
                        :error-messages="prioridadCompetenciasErrors"
                        label="Prioridad Competencias"
                        :box="tipeView == 'consulta'"
                        :readonly="tipeView == 'consulta'"
                        @input="$v.prioridadCompetencias.$touch()"
                        @blur="
                          tipeView == 'crear'
                            ? $v.prioridadCompetencias.$touch()
                            : null
                        "
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12>
                      <v-textarea
                        v-model="instrucciones"
                        label="Instrucciones"
                        :readonly="tipeView == 'consulta'"
                        :box="tipeView == 'consulta'"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-form>
              </template>
              <!-- TERMINO DATOS -->
            </v-flex>
            <v-flex xs12 md1></v-flex>
          </v-layout>
        </v-card>
        <v-card>
          <v-toolbar color="white" dark flat dense cad>
            <v-toolbar-title class="indigo--text"
              ><br /><br />Datos Examinador<br /><br
            /></v-toolbar-title>
          </v-toolbar>
          <v-layout>
            <v-flex xs12 md1></v-flex>
            <v-flex xs12 md12>
              <!-- INICIO DATOS  -->
              <template>
                <v-form ref="form" v-model="validacion" lazy-validation>
                  <v-layout>
                    <v-flex>
                      <v-text-field
                        v-model="rutExaminador"
                        :error-messages="rutExaminador"
                        label="Rut Examinador"
                        :box="tipeView == 'consulta'"
                        :readonly="tipeView == 'consulta'"
                        @input="$v.rutExaminador.$touch()"
                        @blur="
                          tipeView == 'crear' ? $v.rutExaminador.$touch() : null
                        "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md1></v-flex>
                    <v-flex>
                      <v-text-field
                        v-model="nombreExaminador"
                        :error-messages="nombreExaminadorErrors"
                        label="Nombre Examinador"
                        :box="tipeView == 'consulta'"
                        :readonly="tipeView == 'consulta'"
                        @input="$v.nombreExaminador.$touch()"
                        @blur="
                          tipeView == 'crear'
                            ? $v.nombreExaminador.$touch()
                            : null
                        "
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12>
                      <v-textarea
                        v-model="observacion"
                        label="Observaciones"
                        :readonly="tipeView == 'consulta'"
                        :box="tipeView == 'consulta'"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-form>
              </template>
              <!-- TERMINO DATOS -->
            </v-flex>
            <v-flex xs12 md1></v-flex>
          </v-layout>
        </v-card>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { error } from "util";
import { misMixins } from "@/mixins/myMixing.js";
import { mapState, mapActions } from "vuex";
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";

export default {
  name: "FormRevision",
  components: {
    AlertEmpty,
  },
  mixins: [misMixins, validationMixin],
  props: {
    rowsTable: "",
  },

  data() {
    return {
      idAcomodacion: "",
      regionEstudiante: "",
      comunaEstudiante: "",
      rbd: "",
      codigoCurso: "",
      nivel: "",
      letra: "",
      rutEstudiante: "",
      nombreEstudiante: "",
      idDiscapacidad: "",
      tipoDiscapacidad: "",
      asignacionExaminador: "",
      prioridadCompetencias: "",
      instrucciones: "",
      rutExaminador: "",
      nombreExaminador: "",
      observaciones: "",
    };
  },

  validations: {},
  created() {
    this.tipeView = this.$route.params.tipeView;
    this.idAcomodacion = this.$route.params.idAcomodacion;
    this.idContrato = this.$store.getters.contratoStored;
    this.loadData();
  },
  mounted() {},
  computed: {},
  methods: {
    async loadData() {
      this.documento = await this.loadDatosAcomodaciones();
      this.rutEstudiante =
        this.documento.rutEstudiante + "-" + this.documento.dvEstudiante;
      this.nombreEstudiante = this.documento.nombreEstudiante;
      this.regionEstudiante = this.documento.region.nombre;
      this.comunaEstudiante = this.documento.comuna.nombre;
      this.rbd = this.documento.rbd;
      this.codigoCurso = this.documento.codigoCurso;
      this.nivel = this.documento.nivel.descripcion;
      this.letra = this.documento.letra;
      this.idDiscapacidad = this.documento.idDiscapacidad;
      this.tipoDiscapacidad = this.documento.idTipoDiscapacidad;
      this.asignacionExaminador = this.documento.asignacionExaminador;
      this.prioridadCompetencias = this.documento.prioridadCompetencias;
      this.instrucciones = this.documento.instrucciones;
      this.rutExaminador =
        this.documento.candidato.rut + "-" + this.documento.candidato.dv;
      this.nombreExaminador = this.documento.candidato.nombre;
      this.apellidoPaternoExaminador = this.documento.candidato.apellido;
      this.apellidoMaternoExaminador = this.documento.candidato.apellido1;
      this.observaciones = this.documento.observaciones;
    },
    async loadDatosAcomodaciones() {
      return await axios
        .get("/acomodaciones/" + this.idAcomodacion + "/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    volver() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoAplicacion",
        });
      }, 1000);
    },
  },
};
</script>
